<template>
  <div>
    <div class="misc-wrapper" style="margin-top: 10vh">
      <div class="misc-inner">
        <div class="w-100 text-center justify-content-center">
          <b-img class="w-80 px-3 py-2 mb-1"
                 fluid
                 :src="imgUrl"
                 :alt="$t('notAuthorizedPage')"/>
          <br/>
          <small class="mb-2 font-medium-1 text-black-50" style="width: 100%; text-align: center">
            {{ $t('document.attachFilesToDocument') }}
          </small>
        </div>
        <div class="justify-content-center w-100 d-flex mt-2">
          <b-button
              style="height: 40px; "
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              @click="$emit('show-files')"
              class=" btn-sm-block  elevated-btn small px-2 "
              variant="primary">
            {{ $t('add') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {BImg, BButton} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'

export default {
  name: "Empty",
  components: {
    BImg, BButton,
  },
  props: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      modalShow: false,
      emptyImg: require('@/assets/images/illustration/attachments.svg'),
    }
  },
  computed: {
    imgUrl() {
      return this.emptyImg
    },
  },
}
</script>

<style scoped>

</style>
